import React, { useState } from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { TerminosModal } from './TerminosCondiciones';
const WhatsAppIcon = () => <svg viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8" data-id="element-96">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-97" />
  </svg>;
const TikTokIcon = () => <svg viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8" data-id="element-98">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" data-id="element-99" />
  </svg>;
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/aNmuqzhM4ZShZhKE9Q1hg9/WhatsApp_Image_2026-06-01_at_7.48.38_AM_(1)_Nero_AI_Background_Remover_transparent.png';
export function Footer() {
  const [termsOpen, setTermsOpen] = useState(false);
  const quickLinks = [{
    label: 'Inicio',
    href: '#inicio'
  }, {
    label: 'Nosotros',
    href: '#nosotros'
  }, {
    label: 'Servicios',
    href: '#servicios'
  }, {
    label: 'Membresías',
    href: '#membresias'
  }, {
    label: 'Galería',
    href: '#galeria'
  }, {
    label: 'Contacto',
    href: '#contacto'
  }];
  return <>
      <footer className="bg-footerblack border-t-2 border-gold" data-id="element-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-101">
          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-102">
            {/* Column 1 - Brand */}
            <div className="text-center md:text-left" data-id="element-103">
              <img src={LOGO_URL} alt="El Rey Barba Barbería" className="h-20 w-20 object-contain mx-auto md:mx-0 mb-4" data-id="element-104" />
              <p className="text-gold text-sm italic mb-2" data-id="element-105">
                "Rapidez + atención al detalle"
              </p>
              <p className="text-bone/60 text-sm mb-1" data-id="element-106">
                © 2026 El Rey Barba Barbería
              </p>
              <p className="text-bone/60 text-sm" data-id="element-107">Diseñado por NovaWeb 🌐</p>
            </div>

            {/* Column 2 - Quick Links */}
            <div className="text-center" data-id="element-108">
              <h3 className="text-gold font-bold mb-4" data-id="element-109">Enlaces Rápidos</h3>
              <div className="flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-110">
                {quickLinks.map(link => <a key={link.href} href={link.href} className="text-bone hover:text-gold transition-colors text-sm" data-id="element-111">
                    {link.label}
                  </a>)}
              </div>
            </div>

            {/* Column 3 - Contact + Social */}
            <div className="text-center md:text-right" data-id="element-112">
              <h3 className="text-gold font-bold mb-4" data-id="element-113">Contacto</h3>
              <div className="space-y-2 text-bone text-sm mb-4" data-id="element-114">
                <p data-id="element-115">📞 302 828 1216</p>
                <p data-id="element-116">📞 301 701 6307</p>
                <p data-id="element-117">📧 Barberilaelreybarba@gmail.com</p>
                <p data-id="element-118">📍 Cra 71F # 64-15 Sur, Bogotá</p>
              </div>
            </div>
          </div>

          {/* Social Icons Row */}
          <div className="flex justify-center gap-6 mb-8" data-id="element-119">
            <a href="https://instagram.com/barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-white hover:scale-125 transition-all" aria-label="Instagram" data-id="element-120">
              <Instagram className="w-8 h-8" data-id="element-121" />
            </a>
            <a href="https://facebook.com/Barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-white hover:scale-125 transition-all" aria-label="Facebook" data-id="element-122">
              <Facebook className="w-8 h-8" data-id="element-123" />
            </a>
            <a href="https://www.tiktok.com/@pablosievorivas" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-white hover:scale-125 transition-all" aria-label="TikTok" data-id="element-124">
              <TikTokIcon data-id="element-125" />
            </a>
            <a href="https://wa.me/573028281216" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-white hover:scale-125 transition-all" aria-label="WhatsApp" data-id="element-126">
              <WhatsAppIcon data-id="element-127" />
            </a>
          </div>

          {/* Bottom Bar */}
          <div className="text-center border-t border-gold/30 pt-6 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-128">
            <p className="text-bone text-sm" data-id="element-129">
              Abiertos Domingo a Domingo 8:30 AM — 9:30 PM 📍 Barrio Perdomo,
              Bogotá
            </p>
            <button onClick={() => setTermsOpen(true)} className="text-bone/60 hover:text-gold text-xs transition-colors underline-offset-4 hover:underline" data-id="element-130">
              Términos, condiciones y restricciones de uso
            </button>
          </div>
        </div>
      </footer>

      <TerminosModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} data-id="element-131" />
    </>;
}